import { list as getList } from "~/api/userInvitationContract.js";
import * as types from "../mutation-types";

export const state = {
  list: null,
  isLoading: false,
  isInitialLoadPending: true

};

export const mutations = {
  [types.SET_IS_LOAD_USER_INVITATION_CONTRACT](state, status) {
    state.isLoading = status;
  },
  [types.SET_USER_INVITATION_CONTRACT](state, data) {
    state.list = data;
    state.isInitialLoadPending = false;

  }
};

export const actions = {
  fetchUserInvitationContracts({ commit }, userId) {
    commit(types.SET_IS_LOAD_USER_INVITATION_CONTRACT, true);

    getList(userId).then((response) => {
      let { data } = response;
      commit(types.SET_USER_INVITATION_CONTRACT, data.data);
      commit(types.SET_IS_LOAD_USER_INVITATION_CONTRACT, false);
    });
  }
};

export const getters = {
  list: (state) => state.list,
  isLoading: (state) => state.isLoading,
  isInitialLoadPending: (state) => state.isInitialLoadPending,
};
